import { createAction } from "redux-act";

export const REQRegisDeviceList = createAction("REQUEST_REGISDEVICE_LIST");
export const RESRegisDeviceList = createAction("RECEIVE_REGISDEVICE_LIST");
export const FailRegisDeviceList = createAction("FAILED_REGISDEVICE_LIST");
export const CleanUpRegisDeviceList = createAction("CLEANUP_REGISDEVICE_LIST");